import { BookingHistoryTable } from "@/components/organisms/BookingHistory";
import { YourDetailsSection } from "@/components/organisms/YourDetails";

/**
 * EA "My Profile" page (DEV-405). Top-level, assistant-only. Shows the logged-in assistant's OWN
 * profile card (no ClientScopeProvider → YourDetailsSection reads the EA's own /profile) followed by
 * their OWN booking history (self-service BookingHistoryTable). The merged all-managed-clients list
 * lives on the "All Bookings" landing (ClientHome), not here. The stats card is intentionally dropped.
 * Layout/containers mirror ClientHome's main content column.
 */
export const ClientMyProfile = () => {
  return (
    <div className="min-w-0 flex-1 overflow-y-auto px-3 py-6 pb-20 md:px-10 lg:pb-6">
      {/* Cap + centre so content doesn't stretch full-width on ultrawide (DEV-1366; mirrors ClientHome,
          no-op below 2360px). @container sits on the capped wrapper so Your Details' container queries
          measure the real width. */}
      <div className="@container mx-auto flex w-full max-w-[2360px] flex-col gap-10">
        <YourDetailsSection />
        <BookingHistoryTable />
      </div>
    </div>
  );
};
